import { useEffect, useState } from "react";
import { toast } from "sonner";
import { StaffAccounts } from "@/components/staff/StaffAccounts";
import { OutletManager } from "@/components/staff/OutletManager";
import { MaintenancePanel } from "@/components/staff/MaintenancePanel";
import { api, errMsg } from "@/lib/api";

export const SettingsPanel = () => {
  const [s, setS] = useState(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/settings", s);
      setVersion((v) => v + 1);
      toast.success("Pengaturan disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  if (!s) return null;
  const input = "w-full px-3 py-2.5 rounded-lg border border-sage-200 bg-white/70 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30";
  return (
    <div className="grid lg:grid-cols-2 gap-6 items-start">
      <div className="space-y-6">
      <MaintenancePanel />
      <OutletManager />
      <form onSubmit={save} className="card-paper p-6 space-y-4" data-testid="payment-settings-form">
        <h2 className="font-serif font-semibold text-2xl">Pajak</h2>
        <div className="grid grid-cols-2 gap-2">
          <label className="block text-sm"><span className="text-muted2">Nama pajak</span>
            <input required value={s.tax_name} onChange={(e) => setS({ ...s, tax_name: e.target.value })} className={`${input} mt-1`} data-testid="settings-tax-name-input" /></label>
          <label className="block text-sm"><span className="text-muted2">Tarif (%)</span>
            <input required type="number" min="0" max="100" step="0.1" value={s.tax_rate} onChange={(e) => setS({ ...s, tax_rate: Number(e.target.value) })} className={`${input} mt-1`} data-testid="settings-tax-rate-input" /></label>
        </div>
        <p className="text-xs text-muted2">Ditambahkan ke total setelah potongan Coin.</p>
        <h2 className="font-serif font-semibold text-2xl pt-4">Divisi karyawan</h2>
        <div className="grid sm:grid-cols-3 gap-2">
          {(s.divisions || []).map((d, i) => (
            <input key={i} required value={d} onChange={(e) => setS({ ...s, divisions: s.divisions.map((x, j) => (j === i ? e.target.value : x)) })}
              className={input} data-testid={`settings-division-input-${i}`} />
          ))}
        </div>
        <h2 className="font-serif font-semibold text-2xl pt-4">Jam buka</h2>
        <label className="block text-sm">
          <span className="text-muted2">Jam buka</span>
          <input value={s.hours} onChange={(e) => setS({ ...s, hours: e.target.value })} className={`${input} mt-1`} data-testid="settings-hours-input" />
        </label>
        <button className="btn-forest px-6 py-3" data-testid="settings-save-button">Simpan pengaturan</button>
      </form>
      </div>
      <StaffAccounts key={version} />
    </div>
  );
};
